export enum SEARCH {
  HEADING = 'Search results',
}
